<template>
  <rhcn-drawer
    @on-close="onClose"
    v-loading="loading">
    <div class="drawer-form exchange-form" style="width: 637px;">
      <div>
        <rhcn-step :steps="steps"></rhcn-step>
      </div>
      <div class="transfer-money-wrapper">
        <h1 class="title">{{$t('message.transfer.who')}}</h1>
        <div class="margin-top-20">
          <rhcn-input
            v-model="contactName"
            @keyup.enter.native="search"
            @click="search"
            :placeholder="$t('message.transfer.contactName')" suffix="search">
          </rhcn-input>
        </div>
        <div v-permission="'transfer:transfer:add:addContact'">
          <div class="contact-title margin-top-26">{{$t('message.transfer.newContacts')}}</div>
          <div class="contact-add" @click="addContact">
            <div class="item-left">
              <div class="add-icon"><i class="el-icon-plus"></i></div>
              <div>{{$t('message.transfer.addContact')}}</div>
            </div>
            <div><span class="iconfont icon-a-Link1"></span></div>
          </div>
        </div>
        <div v-if="ownContactList && ownContactList.length > 0">
          <div class="contact-title contact-list-title margin-top-40">
            <span>{{$t('message.transfer.ownContacts')}}</span>
            <span v-if="ownContactList.length > 3" class="right" @click="handleExpand('showAllOwnList')">{{showAllOwnList ? $t('message.common.packUp') : $t('message.common.more')}}</span>
          </div>
          <div ref="ownContactListRef" class="contacts-items" :class="{ expand: showAllOwnList }">
            <template v-for="(item, index) in ownContactList">
              <div class="contact-item" @click="toAmount(item)" :key="index">
                <div class="item-left">
                  <div class="avatar">
                    <span class="name">{{getContactName(item.bankAccount)}}</span>
                    <span class="country"><el-image style="width:100%;height:100%" :src="getImage(item.payoutCurrency)" ></el-image></span>
                  </div>
                  <div>
                    <div class="role">{{item.bankAccount}}</div>
                    <div class="info">
                      <span>{{item.bankCountry}}</span>
                      <span class="card">{{item.cardNumber}}</span>
                    </div>
                  </div>
                </div>
                <div><span class="iconfont icon-a-Link1"></span></div>
              </div>
            </template>
          </div>
        </div>

        <div v-if="otherContactList && otherContactList.length > 0">
          <div class="contact-title contact-list-title margin-top-40">
            <span>{{$t('message.transfer.otherContacts')}}</span>
            <span v-if="otherContactList.length > 3" class="right" @click="handleExpand('showAllOtherList')">{{showAllOtherList ? $t('message.common.packUp') : $t('message.common.more')}}</span>
          </div>
          <div ref="otherContactListRef" class="contacts-items" :class="{ expand: showAllOtherList }">
            <template v-for="(item, index) in otherContactList">
              <div class="contact-item" @click="toAmount(item)" :key="index">
                <div class="item-left">
                  <div class="avatar">
                    <span class="name">{{getContactName(item.bankAccount)}}</span>
                    <span class="country"><el-image style="width:100%;height:100%" :src="getImage(item.payoutCurrency)" ></el-image></span>
                  </div>
                  <div>
                    <div class="role">{{item.bankAccount}}</div>
                    <div class="info">
                      <span>{{item.bankCountry}}</span>
                      <span class="card">{{item.cardNumber}}</span>
                    </div>
                  </div>
                </div>
                <div><span class="iconfont icon-a-Link1"></span></div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </rhcn-drawer>
</template>
<script>
import { mapGetters } from 'vuex';

import RhcnDrawer from '@/components/drawer/index.vue';
import RhcnInput from '@/components/form/input.vue';
import RhcnStep from '@/components/step/index.vue';
import { getCurrencyImage } from '@/utils/tools/currency';
import { getContactList } from '@/views/transfer/api/contact';

export default {
  components: { RhcnDrawer, RhcnStep, RhcnInput },
  data() {
    return {
      loading: false,
      steps: [
        {
          title: 'message.transfer.recipient',
        },
        {
          title: 'message.exchange.amount',
        },
        {
          title: 'message.exchange.review',
        },
      ],
      contactName: '',
      contactList: [],
      ownContactList: [],
      otherContactList: [],
      showAllOwnList: false,
      showAllOtherList: false,
      defaultSendCurrency: 'USD',
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    businessType() {
      return this.$route.query.businessType || '';
    },
  },
  created() {
    const { currency } = this.$route.query;
    if (currency) {
      this.defaultSendCurrency = currency;
    }
    this.getContactListData();
  },
  methods: {
    onClose() {
      window.sessionStorage.removeItem('transferData');
      if (this.businessType) {
        this.$router.push({
          path: `/transfer/transfer/aggregate/${this.businessType}`,
        });
      } else {
        this.$router.push({
          path: '/transfer/transfer',
        });
      }
    },
    search() {
      this.getContactListData(this.contactName);
    },
    toAmount(contact) {
      let transferData = {};
      if (window.sessionStorage.getItem('transferData')) {
        try {
          transferData = JSON.parse(window.sessionStorage.getItem('transferData'));
        } catch (err) {
          //
        }
      }
      transferData.contactInfo = contact;
      window.sessionStorage.setItem('transferData', JSON.stringify(transferData));
      this.$router.push({
        path: '/transfer/transfer/add/amount',
        query: { id: contact.cardInfoId, currency: this.defaultSendCurrency, businessType: this.businessType },
      });
    },
    addContact() {
      this.$router.push({
        path: '/transfer/contact/edit',
        query: {
          ...(this.app.userLogin.businessType === '0' || this.businessType === 'payout' ? { from: 'transfer' } : {}),
          ...(this.businessType ? { businessType: this.businessType } : {}),
        },
      });
    },
    getContactListData(name) {
      this.loading = true;
      const params = { size: -1, payeeStatus: 'pass,unnecessary' };
      if (name) {
        params.bankAccount = name;
      }
      params.businessType = this.businessType ? (this.businessType === 'payout' ? 'PAYOUT' : 'ACQUIRING') : null;
      this.ownContactList = [];
      this.otherContactList = [];
      getContactList(params).then((res) => {
        (res.content || []).forEach(item => {
          const accountBelong = +item.accountBelong;
          if (accountBelong === 0) { // 自有
            this.ownContactList.push(item);
          } else { // 他人、VAT
            this.otherContactList.push(item);
          }
        });
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    getContactName(name) {
      if (!name) {
        return '';
      }
      const regex = /[\u4E00-\u9FA5]/;
      const name1 = name.substring(0, 1);
      if (regex.test(name1)) {
        return name1;
      }
      return name.substring(0, 2);
    },
    getImage(currency) {
      return getCurrencyImage(currency) ? require(`@/assets/images/currency/${currency}.png`) : '';
    },
    handleExpand(key) {
      // showAllOwnList: false,
      // showAllOtherList: false,
      if (key === 'showAllOwnList') {
        this.showAllOwnList = !this.showAllOwnList;
        if (!this.showAllOwnList) {
          this.$refs.ownContactListRef.scrollTo({ top: 0 });
        }
      } else if (key === 'showAllOtherList') {
        this.showAllOtherList = !this.showAllOtherList;
        if (!this.showAllOtherList) {
          this.$refs.otherContactListRef.scrollTo({ top: 0 });
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.exchange-form {
  margin-top: -68px;
}
.transfer-money-wrapper {
  padding-top: 54px;
  .title {
    font-size: 24px;
    font-weight: 800;
    line-height: 33px;
    text-align: center;
  }
  .contact-title {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 800;
    line-height: 19px;

    &.contact-list-title {
      padding-bottom: 10px;
      border-bottom: 1px solid #1C4377;
    }

    .right {
      color: $color-text-default-button;
      cursor: pointer;
    }
  }
  .contacts-items {
    max-height: 260px;
    overflow: hidden;
    &.expand {
      max-height: 390px;
      overflow-y: scroll;
    }
    .contact-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 18px 0 12px;
      margin-top: 7px;
      border-radius: 2px;
      height: 80px;
      box-sizing: border-box;
      cursor: pointer;
      .item-left {
        display: flex;
        .avatar {
          position: relative;
          margin-right: 15px;
          .name {
            display: inline-block;
            width: 50px;
            height: 50px;
            background: $color-default;
            border-radius: 50%;
            text-align: center;
            line-height: 50px;
            font-size: 14px;
            font-weight: 800;
            vertical-align: top;
          }
          .country {
            width: 17px;
            height: 17px;
            border-radius: 50%;
            overflow: hidden;
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }
        .role {
          font-size: 16px;
          font-weight: 800;
          line-height: 22px;
        }
        .info {
          font-size: 14px;
          font-weight: normal;
          color: rgba(38,67,115,0.4);
          line-height: 32px;
          .card {
            margin-left: 15px;
          }
        }
      }
      &:hover {
        background: $color-default;
        .item-left {
          .avatar {
            .name {
              background: $color-white;
            }
          }
        }
      }
    }
  }
  .contact-add {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 18px 15px 12px;
    margin-top: 10px;
    background: $color-default;
    border-radius: 2px;
    cursor: pointer;
    .item-left {
      display: flex;
      align-items: center;
      .add-icon {
        display: inline-block;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background: $color-white;
        margin-right: 15px;
        text-align: center;
        .el-icon-plus {
          font-weight: bold;
          line-height: 50px;
        }
      }
    }
  }
  .icon-a-Link1 {
    color: $color-text-default-button;
  }
}
</style>
